var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaveBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      display: "block",
      zIndex: 1,
      position: "relative",
      shapeRendering: "auto"
    },
    width: 1920,
    height: 929,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1920 929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(960,464.5) scale(1,-1) translate(-960,-464.5)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg-0.8245830752035166",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff00ff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.8245830752035166)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "0s",
    values: "M0 0L 0 838.4996946653333Q 192 708.5207450390138  384 670.6911993690042T 768 690.053327724255T 1152 565.9205941052478T 1536 458.25452253052447T 1920 407.6209042914132L 1920 0 Z;M0 0L 0 778.9612628644009Q 192 713.9883300730329  384 699.6615992269059T 768 641.0904046922687T 1152 581.789905515064T 1536 408.3553120066843T 1920 296.8667441076187L 1920 0 Z;M0 0L 0 855.4524895478232Q 192 716.4431078450554  384 682.3796562025348T 768 667.4595187734581T 1152 542.2733027187367T 1536 549.1506927442201T 1920 320.6640609392551L 1920 0 Z;M0 0L 0 838.4996946653333Q 192 708.5207450390138  384 670.6911993690042T 768 690.053327724255T 1152 565.9205941052478T 1536 458.25452253052447T 1920 407.6209042914132L 1920 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.8245830752035166)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-2s",
    values: "M0 0L 0 901.9347579977913Q 192 713.1161120376205  384 679.2269409707552T 768 740.1192260469652T 1152 495.5971107895019T 1536 404.2540043482894T 1920 303.2407530005594L 1920 0 Z;M0 0L 0 896.9878450565122Q 192 701.1616294785008  384 680.2923447132051T 768 726.11546646439T 1152 669.2728515249098T 1536 537.4410820682473T 1920 357.6659718024177L 1920 0 Z;M0 0L 0 922.1880880402402Q 192 708.232998701021  384 686.9778928177941T 768 671.3335977172261T 1152 529.9632625978243T 1536 399.83668131442465T 1920 442.94001036970496L 1920 0 Z;M0 0L 0 901.9347579977913Q 192 713.1161120376205  384 679.2269409707552T 768 740.1192260469652T 1152 495.5971107895019T 1536 404.2540043482894T 1920 303.2407530005594L 1920 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.8245830752035166)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-4s",
    values: "M0 0L 0 880.8677940139892Q 192 834.1048238943307  384 798.9599988253491T 768 732.0087671011574T 1152 576.7609983645416T 1536 484.8913320197405T 1920 471.0349353541021L 1920 0 Z;M0 0L 0 826.3562654173447Q 192 849.8440696892628  384 817.2764853534478T 768 628.249023101689T 1152 536.7299088295557T 1536 426.34610056679315T 1920 336.25279494993424L 1920 0 Z;M0 0L 0 845.5698418859835Q 192 718.8528832766493  384 690.6552371338679T 768 592.7157410278737T 1152 620.629806569974T 1536 496.6901147856702T 1920 317.2218569051004L 1920 0 Z;M0 0L 0 880.8677940139892Q 192 834.1048238943307  384 798.9599988253491T 768 732.0087671011574T 1152 576.7609983645416T 1536 484.8913320197405T 1920 471.0349353541021L 1920 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.8245830752035166)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-6s",
    values: "M0 0L 0 920.6441148977809Q 192 840.2561078876828  384 792.4488817463623T 768 647.214140123571T 1152 652.1090439369967T 1536 453.287156782466T 1920 425.74517610621126L 1920 0 Z;M0 0L 0 862.9445701258088Q 192 729.2115866612485  384 698.2095059451932T 768 586.2106435931555T 1152 615.7006877280082T 1536 494.15716444107284T 1920 302.9442709165403L 1920 0 Z;M0 0L 0 859.7535619012688Q 192 736.7138451034612  384 694.0543261484148T 768 602.5605059357547T 1152 558.9511277599017T 1536 420.6903040291594T 1920 462.7703988771757L 1920 0 Z;M0 0L 0 920.6441148977809Q 192 840.2561078876828  384 792.4488817463623T 768 647.214140123571T 1152 652.1090439369967T 1536 453.287156782466T 1920 425.74517610621126L 1920 0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "url(#lg-0.8245830752035166)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "10s",
    repeatCount: "indefinite",
    keyTimes: "0;0.333;0.667;1",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1",
    begin: "-8s",
    values: "M0 0L 0 875.7492614661794Q 192 813.8039889959819  384 783.2049482058413T 768 690.028744518436T 1152 581.2357115503507T 1536 486.21056105334844T 1920 454.04319244028443L 1920 0 Z;M0 0L 0 889.4518778915572Q 192 698.9947188448948  384 673.1289998595031T 768 748.389882750943T 1152 531.1345920898386T 1536 416.33714491894676T 1920 393.9573983335712L 1920 0 Z;M0 0L 0 770.5513041738037Q 192 829.8873756570938  384 787.3688729328505T 768 651.9738487771662T 1152 584.2351837594424T 1536 474.3375725334826T 1920 367.92670384645135L 1920 0 Z;M0 0L 0 875.7492614661794Q 192 813.8039889959819  384 783.2049482058413T 768 690.028744518436T 1152 581.2357115503507T 1536 486.21056105334844T 1920 454.04319244028443L 1920 0 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveBottom);
export default __webpack_public_path__ + "static/media/wave-bottom.6e34791912e5b978f66d9f57caac6255.svg";
export { ForwardRef as ReactComponent };